export const GET_CAMPAIGN_TOKEN = `U2FsdGVkX19g3BwyuJi8GQUD3JeX9oREOQwrcXmWPpTppWb6s6TpyxJ8xOF2UKtV53QIzxDdjY/AJ9edTtKKzgpCJF+RZLaniaTrveZkouP4xnQjGlyldyj9EuVy1I2wQ46CqrxX2IPs/CGzGuQA4iP/3/E7uzRudrvCms7GW//mtlauGIr96EcGT6AO83CkLftezdeGvgIvnDuUO0Hw8PqWDOuD8Zu1aySkFzythhU=`;

export const GET_CHAT_STATUS = `U2FsdGVkX191wQeIQvSOS2zBjHyAXLFivoEWHGIr+u5hw/j47/fbrcMkbba7f1EAKvpelWD1HbsUu1vdzNTZDmRGbXiYeNXn7YmWoedJaZIR0jktJ/wSRoZn3tsLgMEsMe9QplVdXPrv/EzwxFtr3Yk00vOvS/tSJWFmYNwmg/fYV1db87kzotteF0UBCggeCuBEzdSbwewdu9nOP+Mc/ouYoHXQZ0TLmUjQXA1Gn1Q=`;

export const CHAT_FRAME_STYLE_UPDATE = "CHAT_FRAME_STYLE_UPDATE";

export const VOICE_ICON_HEIGHT = "140px";
export const VOICE_ICON_WIDTH = "55px";

export const VOICE_INPUT_HEIGHT = "140px";
export const VOICE_INPUT_WIDTH = "280px";
